/* eslint-disable @typescript-eslint/no-explicit-any */

import { api, ApiResponse } from '@/api/api';
import { EXTRACTOR_PROVIDER_URLS } from '@/api/url';
import { AnalysisProvider } from '@/types/AnalysisProvider';
import { isAxiosError } from 'axios';

export const apiGetExtractorProviders = async (): Promise<ApiResponse<AnalysisProvider[]>> => {
  try {
    const response = await api.get<ApiResponse<AnalysisProvider[]>>(EXTRACTOR_PROVIDER_URLS.GET);
    return response.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};
